import { render, staticRenderFns } from "./AddWebchat.vue?vue&type=template&id=4abd3dc2"
import script from "./AddWebchat.vue?vue&type=script&lang=js"
export * from "./AddWebchat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports